<ng-template #modalLG let-modal style="border-radius: 8px">
    <div class="modal-content save-modal-content" style="max-height: 90vh; display: flex; flex-direction: column;">
        <div class="modal-header p-0 save-modal-header" style="background-color: transparent; flex-shrink: 0;">
            <button type="button" class=" close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        
        <!-- Section fixe en haut -->
        <div class="save-modal-top-section" style="flex-shrink: 0;">
            <div style="margin: 52px 64px 0 64px;">
                <div class=" text-center " style="margin-bottom: 24px">
                    <h4 class="size24">Enregistrez l'opération</h4>
                </div>
            </div>
        </div>

        <!-- Section scrollable -->
        <div class="modal-body p-0 save-modal-body" tabindex="0" ngbAutofocus style="overflow-y: auto; overflow-x: hidden; flex: 1; min-height: 0;">
            <div style="margin: 0 64px;">

            <div class="items " style="margin-bottom: 24px">
                <div style="flex-grow: 1;">
                    <label>Type de paiement <span class="text-danger">*</span> </label>


                    <div class=" form-options rounded  d-flex justify-content-start border-style " style="gap: 12px;">
                        <label class="type flex-fill  mr-2 cursor-pointer"
                               [class.selected]="productData.type === 'debit'">

                            <input type="radio" id="debit" name="paimentType" value="debit"
                                   [(ngModel)]="productData.type" class="custom-radio">
                            <span class="size15" for="debit">Débit</span>

                        </label>

                        <label class="type flex-fill cursor-pointer"
                               [class.selected]="productData.type === 'credit'">

                            <input type="radio" id="credit" name="paimentType" value="credit"
                                   [(ngModel)]="productData.type" class="custom-radio">
                            <span class="size15"  for="credit">Crédit</span>

                        </label>
                    </div>

                </div>

            </div>
            <div class="center "  style="margin-bottom: 24px">
                <label>Catégorie </label>
                <div class="mb-2">

                    <select class="form-control"
                            [(ngModel)]="formData.categorie"
                            id="basicSelect"
                            name="categorie"
                            [disabled]="categories.length === 0">
                            <option value="">-----</option>
                            <option *ngFor="let cat of categories" [value]="cat.id">{{ cat.nom }}</option>
                    </select>
                    <small *ngIf="categories.length === 0" class="text-muted">Chargement des catégories...</small>
                </div>
            </div>
            <div class="items " style="margin-bottom: 24px">
                <div style="flex-grow: 1;">
                    <label>Méthode de paiement <span class="text-danger">*</span> </label>


                    <div class=" form-options rounded  d-flex justify-content-start border-style " style="gap: 12px;">
                        <label class="type flex-fill  mr-2 cursor-pointer"
                               [class.selected]="formData.methode_paiement === 'espece'">

                            <input type="radio" id="espece" name="methodeType" value="espece"
                                   [(ngModel)]="formData.methode_paiement" class="custom-radio">
                            <span class="size15" for ="espece">Espèces</span>

                        </label>

                        <label class="type flex-fill cursor-pointer"
                               [class.selected]="formData.methode_paiement === 'cheque'">

                            <input type="radio" id="cheque" name="methodeType" value="cheque"
                                   [(ngModel)]="formData.methode_paiement" class="custom-radio">
                            <span class="size15" for ="cheque">Chèque</span>

                        </label>
                    </div>

                </div>

            </div>

            <div class="items"  style="margin-bottom: 24px">
                <div style="flex-grow: 1;">
                    <label>Montant <span class="text-danger">*</span> </label>
                    <input type="number"
                           class="form-control"
                           [(ngModel)]="formData.montant"
                           placeholder="Entrez le montant"
                           name="montant"
                           step="0.001"
                           min="0"
                           required>
                </div>
                <div style="flex-grow: 1;">
                    <label>Date de règlement <span class="text-danger">*</span> </label>
                    <input type="date"
                           class="form-control"
                           [(ngModel)]="formData.date_reglement"
                           name="date_reglement"
                           required>
                </div>
            </div>

            <div class="center "  style="margin-bottom: 24px">
                <label>Note</label>
                <textarea type="text"
                          class="form-control"
                          [(ngModel)]="formData.note"
                          name="note"
                          rows="3"> </textarea>
            </div>
            </div>
        </div>

        <!-- Footer fixe en bas -->
        <div class="save-modal-footer" style="flex-shrink: 0;">
            <div class="centerButtons" style="margin: 0 64px; padding: 16px 0 24px 0;">
                <button type="button" class="btn btn-primary"
                        (click)="confirmOperation()"
                        [disabled]="isLoading"
                        rippleEffect>
                    <span *ngIf="isLoading">Enregistrement...</span>
                    <span *ngIf="!isLoading">Confirmer</span>
                </button>
                <button type="button" class="btn btn-secondary" (click)="modal.close('Accept click')" [disabled]="isLoading" rippleEffect>Annuler
                </button>
            </div>
        </div>
    </div>
</ng-template>
